export default (function (siteVars) {
    return {
        backgroundColor: siteVars.black,
        backgroundColorMine: siteVars.black,
        color: siteVars.white,
        contentFocusOutlineColor: siteVars.yellow,
        border: "1px solid " + siteVars.white,
    };
});
